import axios from 'axios'
import api from '../../api'
import _ from 'lodash'
import {di} from "../../application";

export async function login({commit, dispatch, state}, credentials) {
  try {
    const data = await api.login(credentials.username, credentials.password);
    localStorage.setItem('token', data.token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
    commit('LOAD_ACCOUNT', data);
    let returnUrl = state.auth.returnUrl;
    di.router.push({path: returnUrl})
  } catch (e) {
    return _.get(e, 'code', null)
  }

  return 0
}

export function logout({commit}) {
  localStorage.removeItem('token');
  axios.defaults.headers.common['Authorization'] = '';
  commit('LOGOUT');
  di.router.push({
    name: 'Login',
    query: {
      returnUrl: di.router.history.current.fullPath
    }
  })
}




// WEBPACK FOOTER //
// ./src/store/actions/account.js